export default __webpack_public_path__ + "static/media/1779.fcc0d1ea.png";